// extracted by mini-css-extract-plugin
module.exports =  {"root":"jIbCgEtW8OpHfbaZPE2a"};